import { addNavMenuSection } from '@vendure/admin-ui/core';

export default [
    addNavMenuSection(
        {
            id: 'app-reviews',
            label: 'App Reviews',
            items: [
                {
                    id: 'google-external-app-reviews',
                    label: 'Google App Reviews',
                    routerLink: ['/extensions/app-reviews/google'],
                    icon: 'view-columns',
                },
                {
                    id: 'ios-external-app-reviews',
                    label: 'iOS App Reviews',
                    routerLink: ['/extensions/app-reviews/ios'],
                    icon: 'bubble-exclamation',
                },
            ],
        },
        'marketing',
    ),
];
